import { jsxs as p, jsx as n } from "react/jsx-runtime";
import e from "../../utils/classNames.js";
const L = (c) => {
  const { hasLink: t, icon: i, onClick: s, className: o, children: a, ...m } = c, r = e("ActionBarItemListItem", t && "has-link", o), l = e("ActionBarItemListItemIcon", "rioglyph", i), I = e("ActionBarItemListItemButton");
  return /* @__PURE__ */ p("li", { ...m, className: r, onClick: s, children: [
    i && /* @__PURE__ */ n("span", { className: l }),
    t && !s && /* @__PURE__ */ n("span", { children: a }),
    s && /* @__PURE__ */ n("div", { className: I, children: a }),
    !t && !s && a
  ] });
};
export {
  L as default
};
//# sourceMappingURL=ActionBarItemListItem.js.map
